import React, { useEffect, useRef } from 'react'
import { t } from 'src/translations'
import { Helmet } from 'react-helmet-async'
import UnavailableIcon from 'shared/components/errors/UnavailableIcon'
import StyleMeta, {
  StyleMetaProps
} from 'public/components/default_template/meta/StyleMeta'
import { SiteRestaurantLocation, SiteTheme } from 'shared/js/types'
import { RequestContextProps } from 'src/lib/js/context'
import useTracker from 'src/lib/js/hooks/useTracker'
import LocationDetails from 'shared/components/errors/LocationDetails'
import { TrackingEvents } from 'src/shared/components/common/tracking/TrackingEvents'

const WithFallback500 = ({
  title,
  subtitle,
  errorMessage,
  trackingMessage,
  staticContext,
  meta,
  siteTheme,
  rxName,
  rxLocations
}: Partial<
  {
    title: string
    subtitle: string
    errorMessage?: string
    trackingMessage: TrackingEvents
    meta?: StyleMetaProps
    siteTheme?: SiteTheme
    rxName?: string
    rxLocations?: SiteRestaurantLocation[] | null
  } & RequestContextProps
>) => {
  if (staticContext) {
    staticContext.statusCode = 500
  }
  const trackingRef = useRef(false)
  const tracker = useTracker()
  useEffect(() => {
    if (!trackingRef.current && trackingMessage) {
      tracker.track(trackingMessage, {
        locationDetailsShown: !!rxLocations?.length
      })
      trackingRef.current = true
    }
  }, [tracker, rxLocations, trackingMessage])
  const color = siteTheme?.brandColor ?? meta?.primaryColor ?? '#FF4C00'

  return (
    <div className='errorPageContainer'>
      <StyleMeta {...meta} siteTheme={siteTheme} />
      <Helmet>
        <title>{t('uh-oh.page-title')}</title>
      </Helmet>
      {/* It's already aria-hidden */}
      {/* eslint-disable-next-line @toasttab/buffet/icon-accessibility */}
      <UnavailableIcon color={color} />
      <div className='textContent fallback500'>
        <div className='header'>{title}</div>
        <div className='subheader'>{subtitle}</div>
        {errorMessage && <div className='description'>{errorMessage}</div>}
      </div>
      {rxLocations &&
        rxLocations.map((location) => (
          <LocationDetails
            key={location.id}
            meta={meta}
            siteTheme={siteTheme}
            rxLocation={location}
            rxName={rxLocations.length === 1 ? rxName : undefined}
          />
        ))}
    </div>
  )
}

export default WithFallback500
